<template>
    <div v-if="!!type">
        <veui-dialog
            :open="isShow"
            ui="auto"
            :overlay-class="['free-vip-dialog', type]"
            @cancel="cancel(type + '-close')"
        >
            <div slot="title" class="header">
                <template v-if="configData">
                    <div class="title">
                        {{ configData.title }}
                    </div>
                    <div class="subTitle">
                        {{ configData.subTitle }}
                    </div>
                </template>
                <template v-if="type === 'about-to-expire'">
                    <div class="title">尊敬的{{ passInfo.pass_name }}律师</div>
                    <div class="subTitle">
                        您的体验会员<span class="strong">还剩{{ remainDays }}天</span>，以下权益即将失效，开通会员可保留所有权益
                    </div>
                </template>
            </div>
            <div class="content">
                <free-vip-content size="small"/>
            </div>
            <div slot="foot" class="footer">
                <veui-button
                    v-if="configData && configData.cancelBtn"
                    ui="l"
                    class="btn"
                    :class="configData.btnExtreClass"
                    @click="cancel(type === 'receive-success' ? 'btn-lqcgtc-wzdl' : '')"
                >{{ configData.cancelBtn }}</veui-button>
                <veui-button
                    v-if="type !== 'authorize-success' && type !== 'receive-success'"
                    ui="l"
                    class="btn"
                    @click="handleClick"
                >
                    {{
                        type === "authentice"
                            ? '立即认证'
                            : type === "receive"
                                ? "立即领取"
                                : "授权客服电联，了解更多会员权益"
                    }}
                </veui-button>
            </div>
        </veui-dialog>
    </div>
</template>
<script>
/**
 * @file 免费会员弹窗（领取/失效）
 * @author xingminghua
 */
import {Dialog, Button} from 'veui';
import {mapState, mapActions} from 'vuex';
import FreeVipContent from './free-vip-content';
import dayjs from 'dayjs';
const url = {
    receive: '/bp/api/vip/trialvip/receive',
    authorize: '/bp/api/vip/genvip'
};

export default {
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button,
        'free-vip-content': FreeVipContent
    },
    props: {
        // receive: 领取免费体验会员弹窗
        // receive-success: 免费体验会员领取成功弹窗
        type: {
            type: String,
            default: ''
        },
        // 过期弹窗标题关键词
        expireKeywords: {
            type: String,
            default: ''
        }
    },
    watch: {
        type: {
            immediate: true,
            handler(newVal) {
                this.isShow = true;
                this.$wywLog.send({
                    serverId: 16844,
                    action: 'show',
                    area: newVal
                });
                localStorage.setItem('freeVipModalShow', newVal);
                if (newVal === 'receive') {
                    localStorage.setItem('receiveFreeVipTimer', +new Date());
                }
                else if (newVal === 'about-to-expire') {
                    localStorage.setItem('aboutToExpireFreeVipTimer', new Date());
                }
            }
        },
        isShow(val) {
            if (!val) {
                this.$emit('close');
            }
        }
    },
    data() {
        return {
            // 主体是否展示
            isShow: true,
            // 是否展示授权提示
            isAuthorizeShow: false,
            // 提交中
            isSubmitting: false
        };
    },
    computed: {
        ...mapState({
            userInfoNew: state => state.lawStore?.userInfoNew || {},
            passInfo: state => state.lawStore?.userInfoNew?.pass_info || {},
            authenticationStatus: state =>
                state.lawStore.authenticationStatus,
            vipInfo: state => state.lawStore.vipInfo
        }),
        configData() {
            const {validityEnd} = this.vipInfo || {};
            const validityEndDate = validityEnd ? validityEnd.slice(0, 10) : '';
            switch (this.type) {
                case 'receive':
                    return {
                        title: '您已完成认证，可领取法行宝免费体验会员',
                        subTitle: '体验会员15日，使用超10项律师专属权益',
                        cancelBtn: ''
                    };
                // 认证引导
                case 'authentice':
                    return {
                        title: '完成律师认证并领取免费体验会员，即可解锁该权益',
                        subTitle: '体验会员15日，使用超10项律师专属权益',
                        cancelBtn: ''
                    };
                case 'receive-success':
                    return {
                        title: '恭喜您获得法行宝15天免费体验会员',
                        subTitle: `免费享用11项会员权益，有限期至${validityEndDate}`,
                        cancelBtn: '我知道了',
                        btnExtreClass: 'cancel'
                    };
                case 'authorize-success':
                    return {
                        title: '请保持电话畅通，我们将尽快联系您，为您介绍会员权益',
                        subTitle: '',
                        cancelBtn: '好的'
                    };
                case 'expire-no-avatar':
                    return {
                        title: `体验会员已到期，去了解会员${this.expireKeywords}等权益吧`,
                        subTitle: ''
                    };
            }
            return null;
        },
        remainDays() {
            const {validityEnd} = this.vipInfo || {};
            let days = dayjs(validityEnd)?.diff(dayjs(), 'day', true);
            return days ? Math.ceil(days) : '-';
        }
    },
    methods: {
        ...mapActions({
            getVipInfo: 'lawStore/getVipInfo'
        }),
        cancel(area) {
            area && this.$wywLog.send({
                serverId: 17096,
                action: 'click',
                area
            });
            this.isShow = false;
            this.$emit('cancel');
        },
        handleClick() {
            if (this.isSubmitting) {
                return;
            }
            this.$wywLog.send({
                serverId: 16844,
                action: 'click',
                area: this.type + '-btn'
            });
            // 立即认证
            if (this.type === 'authentice') {
                const isEdit = this.authenticationStatus === 4;
                this.isShow = false;
                this.$router.push({
                    path: '/material',
                    query: {
                        ...(isEdit && {
                            isEdit: 'edit',
                            editAnchor: 'authentice_title'
                        })
                    }
                });
                return;
            }
            this.isSubmitting = true;
            if (this.type === 'receive') {
                this.$http
                    .post(url.receive, {city_level: this.userInfoNew?.lawyer_info?.city_level})
                    .then(res => {
                        if (+res?.code === 0) {
                            setTimeout(() => {
                                this.isShow = false;
                                this.$Message.success({
                                    content:
                                        this.authenticationStatus === 7
                                            ? '免费体验会员领取成功，系统已自动为您激活所有权益~'
                                            : '免费体验权益领取成功~已为您成功激活10项权益，剩余1项权益需您手动点击激活~',
                                    duration: 7
                                });
                                this.getVipInfo();
                                this.$router.push({
                                    name: 'lawservice'
                                });
                            }, 1000);
                        }
                        else {
                            this.$normalizeResponseError(res);
                        }
                    })
                    .finally(() => (this.isSubmitting = false));
            }
            else {
                this.$http
                    .post(url.authorize, {
                        name: this.passInfo?.pass_name
                    })
                    .then(res => {
                        if (+res?.code === 0) {
                            this.isShow = false;
                            this.$emit('changeType', '');
                            this.$emit('showAuthModal');
                            this.$emit('showAuthSuccessModal');
                        }
                        else {
                            this.$normalizeResponseError(res);
                        }
                    })
                    .finally(() => (this.isSubmitting = false));
            }
        }
    }
};
</script>
<style lang='less' scoped>
.free-vip-dialog {
    /deep/ .veui-dialog-content {
        width: 840px;
        height: 620px;
        padding: 0;
        overflow: hidden;
        background-image: linear-gradient(180deg, #facba2 -24.21%, #fff 17.37%);
        position: relative;

        .veui-dialog-content-head {
            background-color: transparent;
            position: relative;
            padding: 30px 20px 24px;

            .veui-dialog-content-head-close {
                position: absolute;
                top: 27px;
                right: 27px;
            }
        }

        .veui-dialog-content-body {
            padding: 2px 20px;
        }

        .veui-dialog-content-foot {
            padding: 0;
        }
    }

    .header {
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;

        .avatar {
            margin-bottom: 20px;
            width: 88px;
            height: 88px;
            border: 4px solid #e5d7cb;
            border-radius: 50%;
            position: relative;

            &::before {
                content: "";
                width: 206px;
                height: 60px;
                position: absolute;
                top: 10px;
                left: 50%;
                transform: translateX(-50%);
                background:


                    url("https://lvlin-base.cdn.bcebos.com/fe-saas/component/free-membership/header-avatar-wing.png")
                    no-repeat;
                background-size: cover;
            }

            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                object-fit: cover;
            }
        }

        .title {
            font-family: PingFangSC-Medium;
            font-size: 24px;
            color: #333;
            line-height: 24px;
            font-weight: 500;
            margin-bottom: 14px;
            min-width: 425px;
            text-align: center;
        }

        .subTitle {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #7a7a7a;
            line-height: 14px;
            font-weight: 400;

            .strong {
                font-family: PingFangSC-Medium;
                color: #333;
                font-weight: 500;
            }
        }
    }

    .content {
        padding-bottom: 88px;
    }

    .footer {
        position: absolute;
        height: 88px;
        width: 100%;
        left: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        background: #fff;
        border-top: 1px solid #ededed;

        .btn {
            min-width: 320px;
            margin-top: 18px;
            height: 40px;
            background-color: #fed9b9;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #401611;
            font-weight: 500;

            &:hover {
                opacity: .8;
            }

            &.cancel {
                background: #fff;
                border: 1px solid #773f00;
            }
        }
    }

    &.receive,
    &.receive-success {
        .header .title {
            position: relative;
        }
    }
}

@supports (-webkit-backdrop-filter: none) or (backdrop-filter: none) {
    .free-vip-dialog .footer {
        background: transparent;
        -webkit-backdrop-filter: blur(20px);
        backdrop-filter: blur(20px);
    }
}
</style>